import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  IconButton,
  Avatar,
  Button,
  Paper,
  InputAdornment,
  Menu,
  MenuItem,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  Select,
  // FormControlLabel,
  // Checkbox,
  Dialog,
  CircularProgress,
  Fab,
  Autocomplete,
  Chip,
} from "@mui/material";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import {
  Search as SearchIcon,
  // FilterList as FilterIcon,
  Add as AddIcon,
  Star as StarIcon,
  // Send as SendIcon,
  // AttachFile as AttachIcon,
  // EmojiEmotions as EmojiIcon,
  Image as ImageIcon,
  // SmartToy as BotIcon,
  // Edit as EditIcon,
  // Delete as DeleteIcon,
  WhatsApp as WhatsAppIcon,
  // Chat as ChatIcon,
  // Flag as FlagIcon,
  LocalOffer as LabelIcon,
  // AccessTime as TimerIcon,
  ArrowDownward as ArrowDownwardIcon,
  AudioFile,
  AudiotrackOutlined,
  StopCircle,
} from "@mui/icons-material";
import ConversationService from "../services/ConversationService";
import { getProperTime } from "../utils/extentions";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import MessageTemplateService from "../services/MessageTemplateService";
import { ContactsSelectDialog } from "../components/ContactsDialog";
import TagService from "../services/TagService";
import ContactApiService from "../services/ContactApiService";
import InsertEmoticonIcon from "@mui/icons-material/InsertEmoticon";
import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';

const TeamChatView = () => {
  const [message, setMessage] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [timer, setTimer] = useState(null);
  const [conversations, setConversations] = useState([]);
  const [page, setPage] = useState(1);
  const [hasNext, setHasNext] = useState(true);
  const [loading, setLoading] = useState(false);
  const [selectedConversationId, setSelectedConversationId] = useState(null);
  const [messages, setMessages] = useState([]);
  const [messagesPage, setMessagesPage] = useState(1);
  const [messagesHasPrev, setMessagesHasPrev] = useState(true);
  const [messagesLoading, setMessagesLoading] = useState(false);
  const [contactname, setContactName] = useState("");
  const [contactemail, setContactEmail] = useState("");
  const [contactId, setContactId] = useState(null);
  const [timeLeft, setTimeLeft] = useState(null);
  const [members, setMembers] = useState(null);
  const [approvedTemplates, setApprovedTemplates] = useState([]);
  const [showChatListMobile, setShowChatListMobile] = useState(true);
  const [sending, setSending] = useState(false);
  const [formData, setFormData] = useState({
    selectedTemplate: "",
    tags: [],
  });
  const [errors, setErrors] = useState({});
  const [templateVariables, setTemplateVariables] = useState({ header: {}, body: {}, footer: {} });
  const [templateDialogOpen, setTemplateDialogOpen] = useState(false);
  const [searchKey, setSearchKey] = useState(null);
  const [open, setOpen] = useState(false);
  const[selectedNewContact, setSelectedNewContact] = useState(null);
  const [contactError, setContactError] = useState(null);
  const messageContainerRef = useRef(null);
  const lastActionRef = useRef(null);
  const [showScrollToBottom, setShowScrollToBottom] = useState(false);
  let container = messageContainerRef.current;
  const [limit, setLimit] = useState(10);
  const timerIntervalRef = useRef();
  const [imageDialogOpen, setImageDialogOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageUploading, setImageUploading] = useState(false);
  const [caption, setCaption] = useState("");
  const [audioDialogOpen, setAudioDialogOpen] = useState(false);
  const [selectedAudio, setSelectedAudio] = useState(null);
  const [audioUploading, setAudioUploading] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [recordedAudio, setRecordedAudio] = useState(null);
  const [mediaStream, setMediaStream] = useState(null);
  const [availableTags, setAvailableTags] = useState([]);
  const [newTag, setNewTag] = useState("");
  const [emojiDialogOpen, setEmojiDialogOpen] = useState(false);
  const [reactingWamid, setReactingWamid] = useState(null);
  const mediaRecorderRef = useRef(null);
const audioChunksRef = useRef([]);
  const recorderRef = useRef(null);
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (!timer) {
      setTimeLeft('Expired');
      return;
    }
    function updateTimer() {
      const now = new Date();
      const targetTime = new Date(timer);
      const diffMs = (targetTime.getTime() + 24 * 60 * 60 * 1000) - now.getTime();
      if (diffMs <= 0) {
        setTimeLeft('Expired');
        setTimer(null);
        if (timerIntervalRef.current) {
          clearInterval(timerIntervalRef.current);
          timerIntervalRef.current = null;
        }
        return;
      }

      const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
      const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
      const formatted = `${String(diffHours).padStart(2, '0')}:${String(diffMinutes).padStart(2, '0')}`;
      setTimeLeft(formatted);
    }

    updateTimer();
    if (timerIntervalRef.current) clearInterval(timerIntervalRef.current);
    timerIntervalRef.current = setInterval(updateTimer, 1000);

    return () => {
      if (timerIntervalRef.current) {
        clearInterval(timerIntervalRef.current);
        timerIntervalRef.current = null;
      }
    };
  }, [timer]);
  const linkRegex = /(https?:\/\/[^\s]+)/g;

function LinkifiedText({ text }) {
  const parts = text.split(linkRegex);

  return (
    <>
      {parts.map((part, index) =>
        linkRegex.test(part) ? (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#1976d2", textDecoration: "underline" }}
          >
            {part}
          </a>
        ) : (
          part
        )
      )}
    </>
  );
}

  async function handleSendMessage() {
    if (message.trim()) {
      try {
        const messagePayload = {
          conversation_id: selectedConversationId,
          message: message.trim(),
          contact_id: contactId,
          message_type: 'text',
          media_id: null,
          media_type: null,
        }
        await ConversationService.sendMessage(messagePayload);
        setSending(true);
        handleClickConversation();
      // fetch(false);
      } catch (error) {
        console.error("Failed Sedning message:", error);
      }
      setMessage("");
      // fetch();
    }
  };

  async function handleSendImage() {
    if (!selectedImage) return;
    setImageUploading(true);
    try {
       const messagePayload = {
          conversation_id: selectedConversationId,
          message: caption?.trim(),
          contact_id: contactId,
          message_type: 'media',
          image: selectedImage,
        }
      await ConversationService.sendMessage(messagePayload);
      setImageDialogOpen(false);
      setSelectedImage(null);
      setCaption("");
      handleClickConversation();
    } catch (error) {
      console.error('Failed to send image:', error);
    }
    setImageUploading(false);
  }

  async function handleSendAudio() {
    if (!selectedAudio) return;
  setAudioUploading(true);
  try {
       const messagePayload = {
          conversation_id: selectedConversationId,
          message: null,
          contact_id: contactId,
          message_type: 'media',
          audio: selectedAudio,
        }
      await ConversationService.sendMessage(messagePayload);
      setAudioDialogOpen(false);
      setSelectedAudio(null);
      setCaption("");
      handleClickConversation();
    } catch (error) {
      console.error('Failed to send image:', error);
    }
    setAudioUploading(false);
  }

  async function stopMicrophone() {
     if (mediaStream) {
      mediaStream.getTracks().forEach(track => track.stop());
      setMediaStream(null);
      console.log("Microphone stopped");
    }
  }

  async function handleSendRecordedAudio() {
    stopMicrophone()
    if (!recordedAudio) return;
    setAudioUploading(true);
    try {
       const messagePayload = {
          conversation_id: selectedConversationId,
          message: null,
          contact_id: contactId,
          message_type: 'media',
          is_voice: true,
          record: recordedAudio,
        }
      await ConversationService.sendMessage(messagePayload);
      setRecordedAudio(null);
      setAudioUploading(false);
      handleClickConversation();
    } catch (error) {
      console.error('Failed to send image:', error);
    }
  }

  function handleSelectContact(contact) {
    if (contact.length > 1) {
     return setContactError('Select only one contact');
    } else if (contact.length === 0) {
     return setContactError('Select atleast one contact');
    } else if (contact.length === 1) {
      setSelectedNewContact(contact);
    }
    setContactError(null);
    setOpen(false);
  }
  const normalizePhone = (s) => {
    if (!s) return "";
    return String(s).replace(/\D/g, "");
  };
  useEffect(() => {
  if (conversations.length > 0 && !selectedConversationId) {
    const firstChat = conversations[0];
    const firstContact = firstChat.members?.[0];

    setSelectedConversationId(firstChat.id);
    handleClickConversation(firstChat, firstContact);
  }
}, [conversations]);

  useEffect(() => {
    if (!selectedNewContact) return;
    const sel = Array.isArray(selectedNewContact) ? selectedNewContact[0] : selectedNewContact;
    if (!sel) return;
    const selPhone = normalizePhone(sel.phoneNumber || sel.phone || sel.phone_number || sel.attrs?.phoneNumber);
    const existingConv = conversations.find((c) =>
      c.members?.some((m) => {
        const mPhone = normalizePhone(m.phone_number || m.phone || m.attrs?.phoneNumber);
        return m.id === sel.id || (mPhone && selPhone && mPhone === selPhone);
      })
    );

    if (existingConv) {
      const contactMember = existingConv.members?.[0];
      handleClickConversation(existingConv, contactMember);
      setSelectedNewContact(null);
      return;
    }
    const tempId = `temp_${sel.attrs.id || selPhone || Date.now()}`;
    const tempConv = {
      id: tempId,
      members: [
        {
          id: sel.attrs.id,
          name: sel.attrs.name || sel.fullName,
          phone_number: sel.attrs.phoneNumber || sel.phone || sel.attrs.phone_number,
        },
      ],
      latest_message: null,
      new_message_count: 0,
      _isTemp: true,
    };
    setConversations((prev) => {
      if (prev.some((c) => c.id === tempConv.id)) return prev;
      return [tempConv, ...prev];
    });
    setSelectedConversationId(tempConv.id);
    setMembers(tempConv.members[0]);
    setMessages([]);
    setMessagesHasPrev(false);
    setMessagesPage(1);
    setContactId(sel.attrs.id);
    setContactName(sel.attrs.name || sel.fullName || sel.phoneNumber);
    setOpen(false);
    setSelectedNewContact(null);
  }, [selectedNewContact, conversations]);
  
  function transformMessages(data) {  
  return data.map((msg) => {
    let isUser;
    if (msg.message_order === "send") {
      isUser = "user";
    } else if (msg.message_order === "receive") {
      isUser = "receive";
    }  else if (msg.message_order === "bot") {
      isUser = "system";
    }

    let buttons;
    let listName;
    let header = null;
    let headerType = null;
    let footer = "";

    if (msg.template?.template_type === 'template') {
      const rawHeader = msg.template?.content?.header;
      if (rawHeader) {
        if (typeof rawHeader === "string") {
          header = rawHeader;
          headerType = "text";
        } else if (typeof rawHeader === "object") {
          header = rawHeader;
          headerType = "media";
        }
      }
      footer = msg.template?.content?.footer;
      if (msg.template?.content?.buttons?.length > 0) {
        const buttonArray = msg.template?.content?.buttons;
        buttons = buttonArray.map((btn) => ({
          btn_label: btn.label,
          btn_value: btn.value,
        }))
      }
    } else if (msg.template?.template_type === 'interactive') {
      const rawHeader = msg.template?.content?.header;
      if (rawHeader) {
        if (typeof rawHeader === "string") {
          header = rawHeader;
          headerType = "text";
        } else if (typeof rawHeader === "object") {
          header = rawHeader;
          headerType = "media";
        }
      }
      footer = msg.template?.content?.footer;
      if (msg.template?.content?.buttons?.length > 0) {
        const buttonArray = msg.template?.content?.buttons;
        buttons = buttonArray.map((btn) => ({
          btn_label: btn.name,
          btn_value: btn.id,
        }))
      } else if (msg.template?.content?.list?.list_row?.length > 0) {
        listName = msg.template?.content?.list?.button_text;
      }
    }
    let orderDetails = null;
    if (msg.message_type === "order" && msg.context) {
      try {
        const ctx = JSON.parse(msg.context);
        const catalogId = ctx.catalog_id;
        const productItems = ctx.product_items || [];
        const currency = productItems[0]?.currency || "";
        const totalPrice = productItems.reduce((sum, item) => sum + (item.item_price * item.quantity), 0);

        orderDetails = {
          catalogId,
          itemsCount: productItems.length,
          currency,
          totalPrice,
        };
      } catch (e) {
        // fallback if parsing fails
      }
    }
    let content = "";
    if (msg.message_type === "order" && orderDetails) {
      content = orderDetails;
    } else {
      content =
        msg.template?.content?.body ||
        (msg.context ? msg.context.replace(/\\n/g, "\n") : "") ||
        msg.template?.text ||
        "";
    }

    return {
      id: msg.id,
      type: isUser,
      header,
      headerType,
      footer,
      content,
      buttons,
      listName,
      mediaUrl: msg.media_url,
      replyId: msg.reply_id,
      wamid: msg.wamid,
      timestamp: msg.created_at,
      message_type: msg.message_type,
      user_reaction: msg.sent_reaction,
      receive_reaction: msg.receive_reaction,
    };
  });
};
async function fetch(isSearch = false) {
  try {
    setLoading(true);
      setLimit(limit);
      if (isSearch) {
        setConversations([]);
      }
      const response = await ConversationService.getConversations({ page, limit: limit, searchKey: searchKey?.trim() });
      TagService.getAllTags().then((res) => setAvailableTags(res));
      const newConversations = response.data || [];
      const pagination = response.pagination;
      if (newConversations.length === 0 && searchKey?.trim()) {
        setConversations([]);
        setHasNext(false);
      setPage(1);
      } else if (searchKey?.trim() && newConversations.length > 0) {
        setConversations([]);
        setConversations(newConversations);
        setHasNext(false);
      } else {
      setConversations((prev) => {
        const combined = [...prev, ...newConversations];
        const uniqueConversationsMap = new Map();
          combined.forEach(conv => {
        uniqueConversationsMap.set(conv.id, conv);
  });
  return Array.from(uniqueConversationsMap.values());
});
      setHasNext(pagination.hasNext);
      setPage(pagination.page + 1);
}
setSending(false);
setLoading(false);
    } catch (error) {
      console.error("Failed to fetch conversations:", error);
    } finally {
      setLoading(false);
    }
}

  const fetchConversations = useCallback(async () => {
    if (loading || !hasNext) return;

    setLoading(true);
    fetch();
  }, [page, hasNext]);


  useEffect(() => {
    setConversations([]);
  setPage(1);
  setHasNext(false);
  fetch(true);
  }, [searchKey]);
  
  useEffect(() => {
    fetchConversations();
    MessageTemplateService.getAllTemplates().then((res) => setApprovedTemplates(res));
  }, []);

  const observer = useRef();
  const lastConversationRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasNext) {
          fetchConversations();
        }
      });

      if (node) observer.current.observe(node);
    },
    [hasNext, fetchConversations]
  );

  async function handleAddTag() {
    const matchedTag = availableTags.find(
      (tag) => tag.getName() === newTag.trim()
    );
  
    if (
      newTag.trim() &&
      matchedTag &&
      !members.tags?.find((t) => t.id === matchedTag.getId())
    ) {

      const updatedTags = [
      ...members.tags,
      {
        id: matchedTag.getId(),
        name: matchedTag.getName(),
        color: matchedTag.getColor(),
      },
    ];

    setFormData((prev) => ({
      ...prev,
      tags: updatedTags,
    }));
    setMembers((prev) => ({
      ...prev,
      tags: updatedTags
    }))

    await ContactApiService.assignTagToContact(contactId, updatedTags);
      setNewTag("");
    }
  };

  async function handleRemoveTag(tagIdToRemove) {
  const updatedTags = members.tags?.filter(tag => tag.id !== tagIdToRemove);

  setMembers(prev => ({
    ...prev,
    tags: updatedTags,
  }));

  setFormData(prev => ({
    ...prev,
    tags: updatedTags,
  }));

  await ContactApiService.assignTagToContact(contactId, updatedTags);
}

    function getTagColor(color) {
    return color || "#757575";
  };

    function handleKeyPress(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      handleAddTag();
    }
  };

  async function handleClickConversation(chat, contact) {
    const container = messageContainerRef.current;
    let response;
    if (chat && contact) {
      setMembers(contact);
      setSelectedConversationId(chat.id);
      setMessages([]);
      setMessagesPage(1);
      setMessagesHasPrev(true);
      setContactId(contact?.id);
      setContactName(contact?.name);
      setContactEmail(contact?.email);
      setTimer(chat.window_time);
      if (window.innerWidth < 900) setShowChatListMobile(false);
      response = await ConversationService.getMessagesByConversation({
        page: 1,
        limit: 10,
        id: chat.id
      });
    } else {
      response = await ConversationService.getMessagesByConversation({
        page: 1,
        limit: 10,
        id: selectedConversationId
      });
    }
    const newMessages = transformMessages(response.data || []);
    const messagesWithDividers = insertDateDividers(newMessages.reverse());
    console.log('message', messagesWithDividers);
    
    setMessages(messagesWithDividers);
    lastActionRef.current = "initial";
    setTimeout(() => scrollToBottom("auto"), 1);
  }
  const scrollToBottom = (behavior = "auto") => {
    const c = messageContainerRef.current;
    if (!c) return;
    requestAnimationFrame(() => {
      c.scrollTo({ top: c.scrollHeight, behavior });
    });
  };

  function handleImageIconClick() {
    setImageDialogOpen(true);
    setCaption("");
    setSelectedImage(null);
  }

  function handleImageChange(e) {
    const file = e.target.files?.[0];
    if (!file) return;
    const allowedTypes = ["image/jpeg", "image/png"];
    if (!allowedTypes.includes(file.type)) {
      alert("Invalid audio format. Allowed: .jpeg, .png");
      return;
    }
    if (file.size > 2 * 1024 * 1024) {
      alert("Image file size must be less than 2MB");
      return;
    }
    setSelectedImage(file);
  }
  function handleAudioIconClick() {
    setAudioDialogOpen(true);
    setSelectedAudio(null);
  }
  function handleAudioChange(e) {
    const file = e.target.files?.[0];
    if (!file) return;
    const allowedTypes = ["audio/aac", "audio/amr", "audio/mp3", "audio/mpeg", "audio/x-m4a", "audio/m4a, audio/mp4"];
    if (!allowedTypes.includes(file.type)) {
      alert("Invalid audio format. Allowed: .aac, .amr, .mp3, .m4a");
      return;
    }
    if (file.size > 10 * 1024 * 1024) {
      alert("Audio file size must be less than 10MB");
      return;
    }
    setSelectedAudio(file);
  }
  useEffect(() => {
    const c = messageContainerRef.current;
    if (!c) {
      setShowScrollToBottom(false);
      return;
    }
    const onScroll = () => {
      const distanceFromBottom = c.scrollHeight - c.scrollTop - c.clientHeight;
      setShowScrollToBottom(distanceFromBottom > 20);
    };
    onScroll();
    c.addEventListener("scroll", onScroll);
    return () => c.removeEventListener("scroll", onScroll);
  }, [messages, messagesLoading, selectedConversationId]);

  const handleScrollToBottom = () => {
    scrollToBottom("smooth");
    setShowScrollToBottom(false);
  };
  useEffect(() => {
    if (!messages || messages.length === 0) return;
    if (lastActionRef.current === "initial") {
      scrollToBottom("auto");
      lastActionRef.current = null;
    }
  }, [messages, selectedConversationId]);

  useEffect(() => {
  if (!container) return;  
  const handleScroll = async () => {
    const oldestMessage = messages
  .filter(msg => msg.timestamp)
  .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp))[0];
    if (container.scrollTop <= 10 && messagesHasPrev && !messagesLoading) {
      setMessagesLoading(true);
      const nextPage = messagesPage + 1;
      const response = await ConversationService.getMessagesByConversation({
        // page: nextPage,
        limit: 10,
        id: selectedConversationId,
        before: oldestMessage?.timestamp ? oldestMessage?.timestamp : null,
      });
      const newMessages = transformMessages(response.data || []);
      if (oldestMessage) {
      setMessages((prev) => {
       const combined = [...newMessages.reverse(), ...prev]
      const uniqueMessagesMap = new Map();
          combined.forEach(conv => {
        uniqueMessagesMap.set(conv.id, conv);
      });
      const dateFormated = Array.from(uniqueMessagesMap.values())
      return insertDateDividers(dateFormated);
});
    }
      setMessagesPage(nextPage);
      setMessagesHasPrev(response.pagination?.hasPrev || false);
      setMessagesLoading(false);
      container.scrollTop = 50;
    }
  };

  container.addEventListener("scroll", handleScroll);
  return () => container.removeEventListener("scroll", handleScroll);
}, [messagesPage, selectedConversationId, messagesHasPrev, messagesLoading, messages]);

const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
    if (field === "selectedTemplate") {
      const selected = approvedTemplates.find(t => t.getId() === value);
      let variableSamples = { header: {}, body: {}, footer: {} };
      try {
        variableSamples = selected ? JSON.parse(selected.attrs.variableSamples) : { header: {}, body: {}, footer: {} };
      } catch (e) {}
      setTemplateVariables({
        header: Object.fromEntries(Object.keys(variableSamples.header || {}).map(k => [k, ""])),
        body: Object.fromEntries(Object.keys(variableSamples.body || {}).map(k => [k, ""])),
        footer: Object.fromEntries(Object.keys(variableSamples.footer || {}).map(k => [k, ""])),
      });
    }
  };

  const handleCloseTemplateDialog = () => {
    setTemplateDialogOpen(false);
  };

  async function handleSave(){
    let convoId;
    if (selectedConversationId?.startsWith('temp_')) {
      convoId = null
    } else {
      convoId = selectedConversationId;
    }
    const messagePayload = {
          conversation_id: convoId,
          message: message.trim(),
          contact_id: contactId,
          message_type: 'text',
          template_id: formData.selectedTemplate,
          variables: templateVariables,
        }
        await ConversationService.sendMessage(messagePayload);
        setFormData({ selectedTemplate: "" });
        setTemplateVariables({ header: {}, body: {}, footer: {} });
        handleCloseTemplateDialog();
  };

  function handleOpenContacts() {
     setOpen(true);
  }
  function handleStopRecording() {
    stopMicrophone();
    mediaRecorderRef.current?.stop();
  setIsRecording(false);
  }
  async function handleStartRecording() {
   try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    setMediaStream(stream);
    const mediaRecorder = new MediaRecorder(stream, {
  mimeType: "audio/webm;codecs=opus"
});
    mediaRecorderRef.current = mediaRecorder;
    audioChunksRef.current = [];

    mediaRecorder.ondataavailable = (event) => {
      if (event.data.size > 0) {
        audioChunksRef.current.push(event.data);
      }
    };

    mediaRecorder.onstop = () => {
      const audioBlob = new Blob(audioChunksRef.current, {
        type: "audio/webm",
      });
      setRecordedAudio(audioBlob);
    };

    mediaRecorder.start();
    setIsRecording(true);
  } catch (err) {
    console.error("Microphone access denied", err);
  }
  }

  function handleEmojiClick(emoji) {
    if (reactingWamid) {
      handleSendReaction(emoji.native, reactingWamid);
      setReactingWamid(null);
      setEmojiDialogOpen(false);
      return;
    }
    setMessage(`${message}${emoji.native}`);
    setEmojiDialogOpen(false);
  };

  async function handleSendReaction(emoji, wamid) {
    if (!emoji || !wamid) return;
    try {
      await ConversationService.sendReaction({ wamid, emoji });
    } catch (error) {
      console.error("Failed to send reaction:", error);
    }
  }

  function renderSendTemplate() {
    const selected = approvedTemplates.find(t => t.getId() === formData.selectedTemplate);
    let variableSamples = { header: {}, body: {}, footer: {} };
    try {
      variableSamples = selected ? JSON.parse(selected.attrs.variableSamples) : { header: {}, body: {}, footer: {} };
    } catch (e) {}
    return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
        <Card sx={{ border: "1px solid #e0e0e0", borderRadius: 2 }}>
          <CardContent sx={{ p: 3 }}>
            <Typography
              variant="h6"
              sx={{ fontWeight: 600, color: "#333", mb: 2, fontFamily: "'Poppins', sans-serif"}}
            >
              Select Templates
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>

              <FormControl
                fullWidth
                size="small"
                error={!!errors.selectedTemplate}
              >
                <InputLabel>Select Template</InputLabel>
                <Select
                  value={formData.selectedTemplate}
                  onChange={(e) =>
                    handleInputChange("selectedTemplate", e.target.value)
                  }
                  label="Select Template"
                >
                  {approvedTemplates.map((template) => (
                    <MenuItem key={template.getId()} value={template.getId()}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                        }}
                      >
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                          {template.getTemplateName()}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {template.getCategory()} • {template.getLanguage()}
                        </Typography>
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
                {errors.selectedTemplate && (
                  <Typography
                    variant="caption"
                    color="error"
                    sx={{ mt: 0.5, ml: 1.5 }}
                  >
                    {errors.selectedTemplate}
                  </Typography>
                )}
              </FormControl>

              {/* Variable input fields for header/body/footer */}
              {["header", "body", "footer"].map((section) => (
                variableSamples[section] && Object.keys(variableSamples[section]).length > 0 && (
                  <Box key={section} sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 1 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 500 }}>
                      {section.charAt(0).toUpperCase() + section.slice(1)} Variables
                    </Typography>
                    {Object.keys(variableSamples[section]).map((key) => (
                      <TextField
                        key={key}
                        label={`Value for {{${key}}}`}
                        value={templateVariables[section][key] || ""}
                        onChange={(e) =>
                          setTemplateVariables((prev) => ({
                            ...prev,
                            [section]: {
                              ...prev[section],
                              [key]: e.target.value,
                            },
                          }))
                        }
                        error={!!errors[`var_${section}_${key}`]}
                        helperText={errors[`var_${section}_${key}`] || `Enter value for {{${key}}}`}
                        fullWidth
                        size="small"
                      />
                    ))}
                  </Box>
                )
              ))}
            </Box>
          </CardContent>
        </Card>
      </Box>
    );
  };

  const ReactionButton = ({ onClick }) => (
  <IconButton
    size="small"
    sx={{
      p: 0.5,
      color: "#6b7280",
      alignSelf: "center",
    }}
    onClick={onClick}
  >
    <InsertEmoticonIcon fontSize="small" />
  </IconButton>
);

  function findMessageById(id) {
    const message = messages.find(
    (msg) => msg.wamid === id
  );
  return message;
};
function handleSearch(value) {
  if(value) {
    setPage(1);
    setSearchKey(value)
  } else {
     setSearchKey(null)
  }
}
const ReactionChip = ({ reactions, align = "right" }) => {
  if (!reactions.length) return null;

  return (
    <Box
      sx={{
        position: "absolute",
        bottom: -10,
        ...(align === "right"
          ? { right: 12 }
          : { left: 12 }),
        bgcolor: "#fff",
        borderRadius: 20,
        px: 0.8,
        py: 0.2,
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        boxShadow: "0 1px 3px rgba(0,0,0,0.25)",
        border: "1px solid #e5e7eb",
        zIndex: 10,
      }}
    >
      {reactions.map((emoji, index) => (
        <Typography key={index} sx={{ fontSize: 14, lineHeight: 1 }}>
          {emoji}
        </Typography>
      ))}

      {reactions.length > 1 && (
        <Typography
          sx={{
            fontSize: 11,
            fontWeight: 600,
            color: "#4b5563",
          }}
        >
          {reactions.length}
        </Typography>
      )}
    </Box>
  );
};

function insertDateDividers(messages) {
  const result = [];
  let lastDate = null;

  for (const msg of messages) {
    if (msg.type !== "date-divider") {
    const msgDate = new Date(msg.timestamp);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const msgDay = msgDate.toDateString();
    const todayStr = today.toDateString();
    const yesterdayStr = yesterday.toDateString();

    let label;

    if (msgDay === todayStr) {
      label = "Today";
    } else if (msgDay === yesterdayStr) {
      label = "Yesterday";
    } else {
      label = msgDate.toLocaleDateString(undefined, {
        day: "numeric",
        month: "short",
        year: "numeric",
      });
    }

    if (lastDate !== msgDay) {
      result.push({
        id: `divider-${msg.id}`,
        type: "date-divider",
        content: label,
      });
      lastDate = msgDay;
    }

    result.push(msg);
  }
}

  return result;
}


  return (
    <Box
      sx={{
        display: "flex",
        height: "100%",
        bgcolor: "#f5f5f5",
        overflow: "hidden",
        // flexDirection: { xs: "column", md: "row" },
      }}
    >
      {/* Chat List Section */}
      <Box
        sx={{
          width: { xs: "100%", md: "20%" },
          minWidth: { xs: 0, md: 240 },
          bgcolor: "white",
          // borderRight: { xs: 0, md: "1px solid #e0e0e0" },
          // borderBottom: { xs: "1px solid #e0e0e0", md: 0 },
          display: {
            xs: showChatListMobile ? "flex" : "none",
            md: "flex"
          },
          flexDirection: "column",
          height: { xs: 'auto', md: '100%' },
          maxHeight: { xs: 820, md: 'none' },
          zIndex: 2,
        }}
      >
        {/* Search & Header */}
       <Box
  sx={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    p: 2,
    gap: 2,
  }}
>


  {/* Search Box */}
  <TextField
            fullWidth
            placeholder="Search"
            size="small"
            onChange={(e) => handleSearch(e.target.value || null)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
  {/* New Message Button */}
<IconButton
  onClick={handleOpenContacts}
  sx={{
    width: 44,
    height: 44,
    bgcolor: "primary.main",
    color: "#fff",
    "&:hover": {
      bgcolor: "primary.dark",
    },
  }}
>
  <AddIcon />
</IconButton>

</Box>

        {/* All Chats Header */}
        <Box sx={{ px: 2 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
             {/* <Typography variant="caption" color="text.secondary">
               New Chats • {conversations.length} 
             </Typography> */}
            {/* <Box>
              <IconButton size="small">
                <FilterIcon />
              </IconButton>
            </Box> */}
          </Box>
        </Box>
        {/* Conversations List */}
      <Box sx={{ flex: 1, overflowY: "auto" }}>
       {conversations.map((chat, index) => {
        const isLast = index === conversations.length - 1;
        const ref = isLast ? lastConversationRef : null;
        const contact = chat.members?.[0];

       return (
        <Paper
        ref={ref}
        key={chat.id}
        onClick={() => handleClickConversation(chat, contact)}
        sx={{
          p: 1.5,
          mb: 1.5,
          cursor: "pointer",
          boxShadow: "none",
          position: "relative",
          borderRadius: 1,
          bgcolor: selectedConversationId === chat.id ? "#eef3ff" : "#fff",
           borderRight:
          selectedConversationId === chat.id
           ? "4px solid #4f7cff"
           : "4px solid transparent",
            "&:hover": {
             bgcolor: "#f5f7fb",
           },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          
          {/* Avatar */}
          <Box sx={{ position: "relative", mr: 1.5 }}>
            <Avatar sx={{ bgcolor: "#1976d2", width: 44, height: 44 }}>
              {contact?.name
                ?.[0]
                ?.split(" ")
                ?.map((n) => n[0])
                ?.join("")
                ?.toUpperCase()}
            </Avatar>

            {/* Online Dot */}
            {/* <Box
              sx={{
                width: 10,
                height: 10,
                bgcolor: "#fbc02d",
                borderRadius: "50%",
                position: "absolute",
                bottom: 2,
                right: 2,
                border: "2px solid #fff",
              }}
            /> */}
          </Box>

          {/* Content */}
          <Box sx={{ flex: 1 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontWeight: 600, fontSize: 14,  fontFamily: `"Poppins", sans-serif`, 
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: { xs: 300, md: 200 },
       }}>
                {contact?.name || "Customer name"}
              </Typography>

              <Typography variant="caption" color="text.secondary">
                {chat?.updated_at
                  ? new Date(chat.updated_at).toLocaleDateString() +
                    "  " +
                    new Date(chat.updated_at).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })
                  : ""}
              </Typography>
            </Box>

         <Typography
  variant="caption"
  color="text.secondary"
  sx={{
    maxWidth: { xs: 250, md: 190 },
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    overflow: "hidden",
    whiteSpace: "nowrap",
  }}
>
  {chat.latest_message?.message_type === "image" && (
    <ImageIcon sx={{ fontSize: 14, flexShrink: 0 }} />
  )}

  {chat.latest_message?.message_type === "audio" && (
    <AudiotrackOutlined sx={{ fontSize: 14, flexShrink: 0 }} />
  )}

  <span
    style={{
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    }}
  >
    {chat.latest_message?.message_type === "order"
      ? "Order Message"
      : chat.latest_message?.message_type === "template"
      ? "Template Message"
      : chat.latest_message?.message_type === "interactive"
      ? "Template Message"
      : chat.latest_message?.message_type === "image"
      ? "Image"
      : chat.latest_message?.message_type === "audio"
      ? "Audio"
      : chat.latest_message?.context || "No message yet"}
  </span>
</Typography>
          </Box>

          {/* Right Actions */}
          <Box sx={{ textAlign: "center", pr: 3 }}>
            {chat.new_message_count > 0 && (
              <Box
                sx={{
                  bgcolor: "#fbc02d",
                  color: "#000",
                  fontSize: 12,
                  fontWeight: 600,
                  width: 22,
                  height: 22,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 0.5,
                }}
              >
                {chat.new_message_count}
              </Box>
            )}

            {/* <Button
              size="small"
              variant="contained"
              sx={{
                textTransform: "none",
                borderRadius: 20,
                fontSize: 12,
                px: 2,
                bgcolor: "#e3ebff",
                color: "#3f5bd8",
                boxShadow: "none",
                "&:hover": { bgcolor: "#d6e0ff" },
              }}
            >
              Open
            </Button> */}
          </Box>
        </Box>
      </Paper>
    );
  })}

  {loading && (
    <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
      <CircularProgress size={20}/>
    </Box>
  )}
</Box>
      </Box>

      {/* Middle Column - Chat Conversation (50%) */}
      <Box
        sx={{
          width: { xs: "100%", md: "50%" },
          bgcolor: "white",
          display: {
            xs: showChatListMobile ? "none" : "flex",
            md: "flex"
          },
          flexDirection: "column",
          height: { xs: '100vh', md: '100%' },
          minHeight: 0,
          position: 'relative',
        }}
      >
        {!selectedConversationId ? (
  /* ===== NO CHAT SELECTED PLACEHOLDER ===== */
  <Box
    sx={{
      flex: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      textAlign: "center",
      bgcolor: "#fcfdff",
      px: 2,
    }}
  >
     <ChatOutlinedIcon
    sx={{
      fontSize: 72,
      color: "#d1d5db",
      mb: 1.5,
    }}
  />
    <Typography
      sx={{
        fontSize: 18,
        fontWeight: 600,
        mb: 1,
        color: "#374151",
        fontFamily: `"Poppins", sans-serif`,
      }}
    >
      Select a conversation Or Create New Message
    </Typography>

    <Typography
      sx={{
        fontSize: 14,
        color: "#9ca3af",
        maxWidth: 300,
        fontFamily: `"Poppins", sans-serif`,
      }}
    >
      Choose a chat from the list to start messaging
    </Typography>
  </Box>
) : (
  /* ===== CHAT SELECTED VIEW ===== */
  <>
         {contactname !== '' && (
          <>
        {/* Chat Header */}
        <Box
          sx={{
            p: 2,
            boxShadow: "0 4px 8px -6px rgba(0,0,0,0.15)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {/* Mobile back button */}
            <Box sx={{ display: { xs: "block", md: "none" }, mr: 1 }}>
              <IconButton onClick={() => setShowChatListMobile(true)}>
                <ArrowDownwardIcon sx={{ transform: 'rotate(90deg)' }} />
              </IconButton>
            </Box>
           {/* Timer Section */}
{timeLeft === "Expired" ? (
  /* ===== EXPIRED TEXT ONLY ===== */
  <Typography
    variant="caption"
    sx={{
      mr: 2,
      fontWeight: 600,
      fontSize: 12,
       fontFamily: `"Poppins", sans-serif`,
      color: "#9e9e9e",
    }}
  >
    Expired
  </Typography>
) : (
  /* ===== ACTIVE TIMER (ROUNDED CLOCK DESIGN) ===== */
  <Box
    sx={{
      position: "relative",
      ml: 4,
      mr: 2,
      width: 56,
      height: 56,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    {/* Outer Ring */}
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        borderRadius: "50%",
        border: "2px solid #4f7cff",
      }}
    />

    {/* Inner Ring */}
    <Box
      sx={{
        position: "absolute",
        inset: 5,
        borderRadius: "50%",
        border: "2px solid #c7d2fe",
      }}
    />

    {/* Top Dot */}
    <Box
      sx={{
        position: "absolute",
        top: -3,
        width: 8,
        height: 8,
        borderRadius: "50%",
        bgcolor: "#4f7cff",
      }}
    />

    {/* Time */}
    <Typography
      variant="caption"
      sx={{
        fontSize: 14,
        fontWeight: 600,
        color: "#4f7cff",
        lineHeight: 1,
      }}
    >
      {timeLeft}
    </Typography>
  </Box>
)}

            <Avatar sx={{ bgcolor: "#1976d2", mr: 2, width: 42, height: 42 }}>
              <Typography variant="caption" sx={{ color: "white", fontSize: 26, fontFamily: `"Poppins", sans-serif` }}>
                {contactname?.[0]}
              </Typography>
            </Avatar>
            <Box>
               <Typography
                   sx={{
                     fontSize: 18,
                     fontWeight: 500,
                      fontFamily: `"Poppins", sans-serif`,
                     lineHeight: 1.2,
                   }}
                 >
                   {contactname}
                 </Typography>
             
                 <Typography
                   sx={{
                     fontSize: 12,
                     color: "#757575",
                      fontFamily: `"Poppins", sans-serif`,
                      display: {
                       xs: "none",
                       md: "block",
                      },
                   }}
                 >
                   {contactemail}
                 </Typography>
            </Box>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {/* <IconButton size="small">
              <StarIcon />
            </IconButton>
            <Button size="small" onClick={handleMenuClick} sx={{ ml: 1 }}>
              Submit as
            </Button> */}
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              <MenuItem onClick={handleMenuClose}>Option 1</MenuItem>
              <MenuItem onClick={handleMenuClose}>Option 2</MenuItem>
            </Menu>
          </Box>
        </Box>
        </>
        )}
        {/* Messages Area */}
        <Box
          ref={messageContainerRef}
          sx={{
            flex: 1,
            p: { xs: 1, md: 2 },
            overflow: "auto",
            position: "relative",
            minHeight: 0,
            bgcolor: '#fcfdff',
            pb: { xs: 15, md: 0 },
          }}
        >
          {messagesLoading && (
            <Box sx={{ display: "flex", justifyContent: "center", py: 1 }}>
              <CircularProgress size={20} />
            </Box>
          )}
  {messages.map((msg) => {
    // Find replied message if any
    const repliedMsg = msg.replyId ? findMessageById(msg.replyId) : null;
    const reactions = [];
    console.log('ree', msg);
    
  if (msg.user_reaction) reactions.push(msg.user_reaction);
  if (msg.receive_reaction) reactions.push(msg.receive_reaction);

  const reactionCount = reactions.length;
    return (
      <Box key={msg.id} sx={{ }}>
      <Box key={msg.id} sx={{ mb: 2 }}>
          {/* React Button for each message */}
          {msg.type === 'date-divider' && (
            <>
              <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
                <Box
                  sx={{
                    bgcolor: '#e0e0e0',
                    color: '#555',
                    px: 2,
                    py: 0.5,
                    borderRadius: '20px',
                    fontSize: '0.75rem',
                    fontWeight: 'bold',
                  }}
                >
                  {msg.content}
                </Box>
              </Box></>
          )}

          {msg.type === "system" && (
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ textAlign: "center", display: "block", mb: 1 }}
            >
              {msg.content}
            </Typography>
          )}
          {msg.type === "user" && (
            <><Box
              id={`msg-${msg.id}`}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                mb: 1.5,
                px: 1,
              }}
            >
                <ReactionButton
      onClick={() => {
        setReactingWamid(msg.wamid);
        setEmojiDialogOpen(true);
      }}
    /> 
              <Paper
                sx={{
                  position: "relative",
                  bgcolor: "#eef3ff",
                  p: 1.5,
                  maxWidth: "70%",
                  borderRadius: "14px 14px 4px 14px",
                  boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                }}
              >
                {reactionCount > 0 && (
  <ReactionChip reactions={reactions} align="right" />
)}
                {/* ===== Bubble Tail (Right) ===== */}
                <Box
                  sx={{
                    position: "absolute",
                    right: -6,
                    bottom: 14,
                    width: 0,
                    height: 0,
                    borderTop: "6px solid transparent",
                    borderBottom: "6px solid transparent",
                    borderLeft: "6px solid #eef3ff",
                  }} />
                {(msg.type === "user") && repliedMsg && (
                  <Box
                    sx={{
                      bgcolor: "#f4f7ff",
                      border: "1px solid #b6ccff",
                      px: 1.5,
                      py: 0.75,
                      mb: 1,
                      borderRadius: "10px",
                      cursor: "pointer",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                    onClick={() => {
                      const el = document.getElementById(`msg-${repliedMsg.id}`);
                      if (el)
                        el.scrollIntoView({ behavior: "smooth", block: "center" });
                    } }
                  >
                    <Typography
                      variant="caption"
                      sx={{
                        fontWeight: 600,
                        color: "#4f7cff",
                        mb: 0.25,
                      }}
                    >
                      {repliedMsg.type === "user" ? "You" : contactname}
                    </Typography>

                    {repliedMsg.message_type === "image" &&
                      repliedMsg.mediaUrl ? (
                      <Box
                        component="img"
                        src={repliedMsg.mediaUrl}
                        alt="image preview"
                        sx={{ maxWidth: 60, maxHeight: 60, borderRadius: 1 }} />
                    ) : (
                      <Typography
                        variant="caption"
                        sx={{
                          color: "#444",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: 240,
                        }}
                      >
                        {typeof repliedMsg.content === "object"
                          ? "[Order / Template]"
                          : repliedMsg.content?.slice(0, 50) || "[No content]"}
                      </Typography>
                    )}
                  </Box>
                )}

                {/* ===== MESSAGE CONTENT (LOGIC UNCHANGED) ===== */}
                {msg.message_type === "order" && typeof msg.content === "object" ? (
                  <Box>
                    <Typography variant="body2" sx={{ fontWeight: 700 }}>
                      Catalog ID: {msg.content.catalogId}
                    </Typography>
                    <Typography variant="body2">
                      {msg.content.itemsCount} item
                      {msg.content.itemsCount > 1 ? "s" : ""}
                    </Typography>
                    <Typography variant="body2">
                      {msg.content.currency} {msg.content.totalPrice}
                    </Typography>
                  </Box>
                ) : msg.message_type === "image" ? (
                  <>
                    <Box
                      component="img"
                      src={msg.mediaUrl}
                      alt="image"
                      sx={{ width: "100%", borderRadius: 2, mb: 1 }} />
                    <Typography
                      variant="body2"
                      sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
                    >
                      <LinkifiedText text={msg.content} />
                    </Typography>
                  </>
                ) : msg.message_type === "audio" ? (
                  <>
                    <Box component="audio" src={msg.mediaUrl} controls />
                    <Typography
                      variant="body2"
                      sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
                    >
                      {msg.content}
                    </Typography>
                  </>
                ) : (
                  <>
                    {msg.headerType === "text" && msg.header && (
                      <Typography variant="body2" sx={{ fontWeight: 700, mb: 0.5 }}>
                        {msg.header}
                      </Typography>
                    )}

                    {msg.headerType === "media" && msg.header && (
                      <Box sx={{ mb: 1 }}>
                        {(msg.header.media_type === "image" ||
                          msg.header.media_type === "photo") &&
                          msg.header.media_url && (
                            <Box
                              component="img"
                              src={msg.header.media_url}
                              alt="header"
                              sx={{ maxWidth: "100%", borderRadius: 2, mb: 1 }} />
                          )}
                      </Box>
                    )}

                    <Typography
                      variant="body2"
                      sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
                    >
                      <LinkifiedText text={msg.content} />
                    </Typography>

                    {msg.footer && (
                      <Typography
                        variant="caption"
                        sx={{ color: "#777", display: "block", mt: 0.5 }}
                      >
                        {msg.footer}
                      </Typography>
                    )}
                  </>
                )}

                {/* ===== TIME + DOUBLE TICK ===== */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: 0.5,
                    mt: 0.5,
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{ fontSize: 11, color: "#6b7280" }}
                  >
                    {getProperTime(msg.timestamp)}
                  </Typography>

                  {/* Double Tick */}
                  <Box sx={{ display: "flex" }}>
                    <Box
                      sx={{
                        width: 4,
                        height: 8,
                        borderBottom: "2px solid #4f7cff",
                        borderRight: "2px solid #4f7cff",
                        transform: "rotate(45deg)",
                      }} />
                    <Box
                      sx={{
                        width: 4,
                        height: 8,
                        borderBottom: "2px solid #4f7cff",
                        borderRight: "2px solid #4f7cff",
                        transform: "rotate(45deg)",
                        ml: "-2px",
                      }} />
                  </Box>
                </Box>

                {/* ===== Buttons & List (UNCHANGED) ===== */}
                {msg.buttons && (
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 1 }}>
                    {msg.buttons.map((button, btnIndex) => (
                      <Button
                        key={btnIndex}
                        onClick={button.btn_value}
                        size="small"
                        variant="outlined"
                        fullWidth
                        sx={{
                          borderRadius: 20,
                          textTransform: "none",
                        }}
                      >
                        {button.btn_label}
                      </Button>
                    ))}
                  </Box>
                )}

                {msg.listName && (
                  <Typography variant="body2" sx={{ mt: 1, fontWeight: 500 }}>
                    {msg.listName}
                  </Typography>
                )}
              </Paper>
            </Box>
            </>
          )}

          {msg.type === "receive" && (
            <Box
              id={`msg-${msg.id}`}
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                mb: 1.5,
                px: 1,
              }}
            >
              <Paper
                sx={{
                  position: "relative",
                  bgcolor: "#ffffff",
                  p: 1.5,
                  maxWidth: "70%",
                  borderRadius: "12px",
                  boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                }}
              >
                {reactionCount > 0 && (
  <ReactionChip reactions={reactions} align="left" />
)}
                {/* ===== Reply Preview (UNCHANGED LOGIC – DESIGN SOFTENED) ===== */}
                {repliedMsg && (
                  <Box
                    sx={{
                      bgcolor: "#f5f5f5",
                      borderLeft: "3px solid #c7d2fe",
                      px: 1.25,
                      py: 0.5,
                      mb: 1,
                      borderRadius: 1,
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      const el = document.getElementById(`msg-${repliedMsg.id}`);
                      if (el)
                        el.scrollIntoView({ behavior: "smooth", block: "center" });
                    } }
                  >
                    <Typography
                      variant="caption"
                      sx={{
                        fontWeight: 600,
                        color: "#4f7cff",
                        display: "block",
                        mb: 0.25,
                      }}
                    >
                      {repliedMsg.type === "user" ? "You" : contactname}
                    </Typography>

                    {repliedMsg.message_type === "image" &&
                      repliedMsg.mediaUrl ? (
                      <Box
                        component="img"
                        src={repliedMsg.mediaUrl}
                        alt="preview"
                        sx={{ maxWidth: 60, maxHeight: 60, borderRadius: 1 }} />
                    ) : (
                      <Typography
                        variant="caption"
                        sx={{
                          color: "#555",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: 220,
                        }}
                      >
                        {typeof repliedMsg.content === "object"
                          ? "[Order / Template]"
                          : repliedMsg.content?.slice(0, 50) || "[No content]"}
                      </Typography>
                    )}
                  </Box>
                )}

                {/* ===== MESSAGE CONTENT (LOGIC UNCHANGED) ===== */}
                {msg.message_type === "order" && typeof msg.content === "object" ? (
                  <Box>
                    <Typography variant="body2" sx={{ fontWeight: 700 }}>
                      Catalog ID: {msg.content.catalogId}
                    </Typography>
                    <Typography variant="body2">
                      {msg.content.itemsCount} item
                      {msg.content.itemsCount > 1 ? "s" : ""}
                    </Typography>
                    <Typography variant="body2">
                      {msg.content.currency} {msg.content.totalPrice}
                    </Typography>
                  </Box>
                ) : msg.message_type === "image" ? (
                  <>
                    <Box
                      component="img"
                      src={msg.mediaUrl}
                      alt="image"
                      sx={{ maxWidth: "100%", borderRadius: 2, mb: 1 }} />
                    <Typography
                      variant="body2"
                      sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
                    >
                      <LinkifiedText text={msg.content} />
                    </Typography>
                  </>
                ) : msg.message_type === "audio" ? (
                  <>
                    <Box component="audio" src={msg.mediaUrl} controls />
                    <Typography
                      variant="body2"
                      sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
                    >
                      {msg.content}
                    </Typography>
                  </>
                ) : (
                  <>
                    {msg.headerType === "text" && msg.header && (
                      <Typography variant="body2" sx={{ fontWeight: 700, mb: 0.5 }}>
                        {msg.header}
                      </Typography>
                    )}

                    {msg.headerType === "media" && msg.header && (
                      <Box sx={{ mb: 1 }}>
                        {(msg.header.media_type === "image" ||
                          msg.header.media_type === "photo") &&
                          msg.header.media_url && (
                            <Box
                              component="img"
                              src={msg.header.media_url}
                              alt="header"
                              sx={{ maxWidth: "100%", borderRadius: 2, mb: 1 }} />
                          )}
                      </Box>
                    )}

                    <Typography
                      variant="body2"
                      sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
                    >
                      <LinkifiedText text={msg.content} />
                    </Typography>

                    {msg.footer && (
                      <Typography
                        variant="caption"
                        sx={{ color: "#777", display: "block", mt: 0.5 }}
                      >
                        {msg.footer}
                      </Typography>
                    )}
                  </>
                )}

                {/* ===== TIME (RIGHT INSIDE BUBBLE) ===== */}
                <Typography
                  variant="caption"
                  sx={{
                    display: "block",
                    textAlign: "right",
                    fontSize: 11,
                    color: "#9ca3af",
                    mt: 0.5,
                  }}
                >
                  {getProperTime(msg.timestamp)}
                </Typography>
              </Paper>
            <ReactionButton
      onClick={() => {
        setReactingWamid(msg.wamid);
        setEmojiDialogOpen(true);
      }}
    />
    
            </Box>
          )}

        </Box></Box>
  )})}
</Box>
 <div style={{ display: "flex", justifyContent: "flex-end"}}>
            {showScrollToBottom && (
           <Fab
             color="primary"
             size="small"
             onClick={handleScrollToBottom}
             aria-label="scroll to bottom"
             sx={{
              display: "flex",
               position: "absolute",
               bottom: 106,
               zIndex: 20,
               boxShadow: 3,
               opacity: '50%',
             }}
           >
             <ArrowDownwardIcon />
           </Fab>
         )}
</div>

        {/* Message Input */}
<Box
  sx={{
    px: { xs: 1.5, md: 2 },
    py: 1.5,
    // borderTop: "1px solid #e6e6e6",
    bgcolor: "#fff",
    position: { xs: "fixed", md: "sticky" },
    bottom: 0,
    left: 0,
    width: "100%",
    zIndex: 30,
    boxShadow: "0 -4px 8px -6px rgba(0,0,0,0.15)",
  }}
>
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1,
      bgcolor: "#f5f7fb",
      borderRadius: "28px",
      px: 2,
      py: 0.5,
    }}
  >
    {/* Text Input */}
    {!recordedAudio &&
    <><TextField
                    fullWidth
                    placeholder={timer && !isRecording
                      ? "Type message here"
                      : isRecording ? "Speak now..." :"Conversation window expired. Use templates"}
                    value={message}
                    disabled={!timer}
                    onChange={(e) => setMessage(e.target.value)}
                    multiline
                    minRows={1}
                    maxRows={1}
                    onKeyPress={(e) => {
                      if (e.key === "Enter" && e.ctrlKey) {
                        e.preventDefault();
                        handleSendMessage();
                      }
                    } }
                    variant="standard"
                    InputProps={{
                      disableUnderline: true,
                      sx: {
                        fontSize: 14,
                        px: 1,
                      },
                      endAdornment: (
                        <InputAdornment position="end">
                          {/* Emoji */}
                          <IconButton
                            size="small"
                            disabled={!timer}
                            onClick={() => setEmojiDialogOpen(true)}
                            sx={{ color: "#9e9e9e" }}
                          >
                            <InsertEmoticonIcon fontSize="small" />
                          </IconButton>
                          {/* Image */}
                          <IconButton
                            size="small"
                            disabled={!timer}
                            onClick={handleImageIconClick}
                            sx={{ color: "#9e9e9e" }}
                          >
                            <ImageIcon fontSize="small" />
                          </IconButton>

                          {/* Audio */}
                          <IconButton
                            size="small"
                            disabled={!timer}
                            onClick={handleAudioIconClick}
                            sx={{ color: "#9e9e9e" }}
                          >
                            <AudioFile fontSize="small" />
                          </IconButton>
                          <IconButton size="small" sx={{ mr: 0.5 }} disabled={!timer || isRecording} onClick={handleStartRecording}>
                            <span role="img" aria-label="mic">🎤</span>
                          </IconButton>
                          {isRecording && (
                            <IconButton size="small" color="error" onClick={handleStopRecording}>
                              <span role="img" aria-label="stop"><StopCircle /></span>
                            </IconButton>
                          )}
                        </InputAdornment>
                      ),
                    }} /><>
                      {/* Send Button */}
                      {timer ? (
                        <Button
                          variant="contained"
                          onClick={handleSendMessage}
                          sx={{
                            borderRadius: "20px",
                            px: 3,
                            py: 1,
                            textTransform: "none",
                            fontWeight: 600,
                            minWidth: "auto",
                          }}
                        >
                          Send
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          onClick={() => setTemplateDialogOpen(true)}
                          sx={{
                            borderRadius: "20px",
                            px: 3.5,
                            py: 1,
                            textTransform: "none",
                            fontWeight: 600,
                            minWidth: "auto",
                          }}
                        >
                          Templates
                        </Button>
                      )}
                    </></>
    }
    {recordedAudio && (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent:'flex-end' }}>
      <audio controls src={URL.createObjectURL(recordedAudio)} style={{ width: 190 }} />
      <Button
        variant="contained"
        color="primary"
        onClick={handleSendRecordedAudio}
        disabled={audioUploading}
        sx={{ minWidth: "auto", px: 2, py: 1, borderRadius: "20px", textTransform: "none", fontWeight: "bold" }}
      >
        {audioUploading ? <CircularProgress size={20} /> : 'Send Voice'}
      </Button>
      <Button onClick={() => {
        setRecordedAudio(null);
        stopMicrophone();
        }} disabled={audioUploading}>Cancel</Button>
    </Box>
  )}
  </Box>
</Box>

        </>
        )}
      </Box>
     
    {/* Contact Information Content - Scrollable */}
<Box
  sx={{
    flex: 1,
    overflowY: "auto",
    bgcolor: "#ffffff",
  }}
>
  {/* ================= BASIC INFORMATION ================= */}
  {/* Contact Header */}
<Box sx={{ p: 1.4, 
  //  borderBottom: "1px solid #e0e0e0",
   bgcolor: "#fff" }}>
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    }}
  >
    {/* Left Section */}
    <Box sx={{ display: "flex", alignItems: "center" }}>
      {/* Avatar */}
      <Avatar
        sx={{
          bgcolor: "#1976d2",
          width: 44,
          height: 44,
          mr: 2,
          fontSize: 20,
        
        }}
      >
        {members?.name
          ?.[0]
          ?.split(" ")
          ?.map((n) => n[0])
          ?.join("")
          ?.toUpperCase()}
      </Avatar>

      {/* Name & Status */}
      <Box>
        <Typography
          variant="body1"
          sx={{ fontWeight: 600, lineHeight: 1.2,  fontFamily: `"Poppins", sans-serif`, width: '300px',
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap" }}
        >
          {members?.name || "Customer name"}
        </Typography>

        {/* <Box sx={{ display: "flex", alignItems: "center", mt: 0.3 }}>
          <Box
            sx={{
              width: 8,
              height: 8,
              bgcolor: "#22c55e",
              borderRadius: "50%",
              mr: 0.7,
            }}
          />
          <Typography
            variant="caption"
            sx={{ color: "#22c55e", fontWeight: 500, fontFamily: `"Poppins", sans-serif` }}
          >
            Available
          </Typography>
        </Box> */}
      </Box>
    </Box>

    {/* Right Section */}
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <IconButton
         component="a"
         href={`https://wa.me/${members?.phone_number}`}
         target="_blank"
         rel="noopener noreferrer"
         sx={{
          bgcolor: "#e8f5e9",
          color: "#25D366",
         "&:hover": { bgcolor: "#dff3e3" },
          }}
       >
  <WhatsAppIcon fontSize="small" />
</IconButton>

{/* 
      <IconButton
        size="small"
        sx={{
          bgcolor: "#f1f5f9",
          color: "#555",
          "&:hover": { bgcolor: "#e5e7eb" },
        }}
      >
        <ChatIcon fontSize="small" />
      </IconButton> */}
    </Box>
  </Box>
</Box>

  <Box sx={{ p: 2, mx: 2, my: 1, borderRadius: 2,
    //  borderBottom: "1px solid #eaeaea" 
    boxShadow: "0 1px 3px rgba(0,0,0,0.15)"
     }}>
    <Typography sx={{  fontFamily: `"Poppins", sans-serif`, fontWeight: 600, mb: 1.5 }}>
      Basic Information
    </Typography>

    <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
      <Typography variant="body2" sx={{  fontFamily: `"Poppins", sans-serif`, color: "#666", mr: 1 }}>
        Phone Number :
      </Typography>

      <Typography variant="body2" sx={{  fontFamily: `"Poppins", sans-serif`, fontWeight: 500 }}>
        {members?.phone_number}
      </Typography>

      <Box
        component="img"
        src="https://flagcdn.com/w20/in.png"
        alt="flag"
        sx={{ width: 20, height: 14, ml: 1 }}
      />
    </Box>

    <Typography variant="body2" sx={{ color: "#666", fontFamily: `"Poppins", sans-serif` }}>
      E-mail : {members?.email}
    </Typography>
  </Box>
  {/* ================= CONTACT CUSTOM PARAMETERS ================= */}
  {/* <Box sx={{ p: 2, borderBottom: "1px solid #eaeaea" }}> */}
    {/* <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 1.5,
      }}
    >
      <Typography sx={{ fontWeight: 600 ,  fontFamily: `"Poppins", sans-serif` }}>
        Contact custom parameters
      </Typography>

      <IconButton size="small">
        <EditIcon fontSize="small" />
      </IconButton>
    </Box> */}

    {/* Parameter Row */}
    {/* <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        p: 1,
        mb: 1,
        borderRadius: 1,
        border: "1px solid #e5e7eb",
      }}
    >
      <Typography variant="body2" sx={{ color: "#555" , fontFamily: `"Poppins", sans-serif` }}>
        Name
      </Typography>

      <Box sx={{ display: "flex", alignItems: "center", gap: 1  }}>
        <Typography variant="body2">
          {members?.name}
        </Typography>
        <IconButton size="small">✕</IconButton>
      </Box>
    </Box> */}
  {/* </Box> */}

  {/* ================= TAGS ================= */}
  <Box sx={{ p: 2, boxShadow: "0 1px 3px rgba(0,0,0,0.15)", mx: 2, my: 2, borderRadius: 2,
    // borderBottom: "1px solid #eaeaea"
     }}>
    <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
      <LabelIcon sx={{ mr: 1, color: "#666" }} />
      <Typography sx={{ fontWeight: 600 ,  fontFamily: `"Poppins", sans-serif` }}>
        Tags
      </Typography>
    </Box>

    <Box sx={{ display: "flex", gap: 1 }}>
                <Autocomplete
                  freeSolo
                  options={availableTags.filter(
                    (tag) => !members?.tags?.find((selected) => selected.id === tag.getId())
                  )?.map((tag) => tag.getName())}
                  getOptionLabel={(option) => (typeof option === "string" ? option : option.name)}
                  value={newTag}
                  onChange={(_, value) => {
                    if (typeof value === "string") {
                      setNewTag(value);
                    } else if (value && value.name) {
                      setNewTag(value.name);
                    } else {
                      setNewTag("");
                    }
                  }}
                  onInputChange={(_, value) => setNewTag(value)}
                  onKeyPress={handleKeyPress}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Add a tag..."
                      size="small"
                      width={150}
                      sx={{
                        flex: 1,
                        width: 150,
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                        },
                      }}
                    />
                  )}
                />
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleAddTag}
                  disabled={!newTag.trim()}
                  sx={{ borderRadius: 2, minWidth: "auto", px: 2 }}
                >
                  <AddIcon fontSize="small" />
                </Button>
              </Box>
               {members?.tags?.length > 0 &&
      members.tags?.map((tag) => (
            <Chip
              key={tag.id}
              label={tag.name}
              onDelete={() => handleRemoveTag(tag.id)}
              size="small"
              sx={{
              backgroundColor: `${getTagColor(tag.color)}15`,
              color: getTagColor(tag.color),
              fontWeight: 500,
              fontSize: "0.75rem",
              fontFamily: "Poppins, sans-serif",
              marginTop: 1,
              marginRight: 1
              }}
            />
  ))}
  </Box>

  {/* ================= NOTES ================= */}
   {members?.notes?.length > 0 &&
      members.notes.map((note) => (
  <Box sx={{ p: 2, boxShadow: "0 1px 3px rgba(0,0,0,0.15)", mx: 2, my: 2, borderRadius: 2, }}>
    <Typography sx={{ fontWeight: 600, mb: 2 ,  fontFamily: `"Poppins", sans-serif` }}>
      Notes
    </Typography>

        <Box
          key={note.id}
          sx={{
            mb: 2,
            p: 2,
            borderRadius: 1,
            border: "1px solid #e5e7eb",
            bgcolor: "#fafafa",
          }}
        >
          <Typography
            variant="caption"
            sx={{ color: "#999", display: "block", mb: 0.5, fontFamily: `"Poppins", sans-serif`}}
          >
            {note.author} • {note.date}
          </Typography>

          <Typography variant="body2" sx={{ fontFamily: `"Poppins", sans-serif`}}>
            {note.text}
          </Typography>
        </Box>
  </Box>
  ))}
</Box>


      <ContactsSelectDialog
      open={open}
      setOpen={setOpen}
      setSelectedNewContacts={handleSelectContact}
      contactError={contactError}
      />

      {/* Template Dialog */}
      <Dialog
        open={templateDialogOpen}
        onClose={handleCloseTemplateDialog}
        maxWidth="md"
        fullWidth
      >
        <Box sx={{ p: 2 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
            <Typography variant="h6" sx={{ fontFamily: "Poppins, sans-serif" }}>Send Template</Typography>
            {/* <IconButton onClick={handleCloseTemplateDialog} size="small">
              <DeleteIcon /> 
            </IconButton> */}
          </Box>
          {renderSendTemplate()}
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 2 }}>
            <Button onClick={handleCloseTemplateDialog}>Cancel</Button>
            <Button
              variant="contained"
              onClick={() => {
                handleSave();
              }}
            >
              Send Template
            </Button>
          </Box>
        </Box>
      </Dialog>

      {/* Image Upload Dialog */}
      <Dialog
        open={imageDialogOpen}
        onClose={() => { setImageDialogOpen(false); setSelectedImage(null); setCaption(""); }}
        maxWidth="xs"
        fullWidth
      >
        <Box sx={{ p: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
          <Typography variant="h6">Upload Image</Typography>
          <input
            accept="image/*"
            type="file"
            style={{ display: 'none' }}
            id="image-upload-input"
            onChange={handleImageChange}
          />
          <label htmlFor="image-upload-input">
            <Button variant="outlined" component="span">
              Choose Image
            </Button>
          </label>
          {selectedImage && (
            <>
              <Box sx={{ mt: 2, mb: 2 }}>
                <img
                  src={URL.createObjectURL(selectedImage)}
                  alt="preview"
                  style={{ maxWidth: 200, maxHeight: 200, borderRadius: 8 }}
                />
              </Box>
              <TextField
                label="Add a caption"
                value={caption}
                onChange={e => setCaption(e.target.value)}
                fullWidth
                size="small"
                multiline
                maxRows={3}
                sx={{ mt: 1, mb: 1 }}
              />
            </>
          )}
          <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
            <Button onClick={() => { setImageDialogOpen(false); setSelectedImage(null); setCaption(""); }} disabled={imageUploading}>Cancel</Button>
            <Button
              variant="contained"
              onClick={handleSendImage}
              disabled={!selectedImage || imageUploading}
            >
              {imageUploading ? <CircularProgress size={20} /> : 'Send Image'}
            </Button>
          </Box>
        </Box>
      </Dialog>

      {/* Audio Upload Dialog */}
      <Dialog
        open={audioDialogOpen}
        onClose={() => { setAudioDialogOpen(false); setSelectedAudio(null); }}
        maxWidth="xs"
        fullWidth
      >
        <Box sx={{ p: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
          <Typography variant="h6">Upload Audio</Typography>
          <input
            accept=".aac,.amr,.mp3,.m4a"
            type="file"
            style={{ display: 'none' }}
            id="audio-upload-input"
            onChange={handleAudioChange}
          />
          <label htmlFor="audio-upload-input">
            <Button variant="outlined" component="span">
              Choose Audio
            </Button>
          </label>
          {selectedAudio && (
            <>
              <Box sx={{ mt: 2, mb: 2 }}>
                <audio controls src={URL.createObjectURL(selectedAudio)} style={{ width: 200 }} />
              </Box>
            </>
          )}
          <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
            <Button onClick={() => { setAudioDialogOpen(false); setSelectedAudio(null); }} disabled={audioUploading}>Cancel</Button>
            <Button
              variant="contained"
              onClick={handleSendAudio}
              disabled={!selectedAudio || audioUploading}
            >
              {audioUploading ? <CircularProgress size={20} /> : 'Send Audio'}
            </Button>
          </Box>
        </Box>
      </Dialog>

      {/* Emoji Dialog for message reaction or sending emoji */}
      <Dialog
        open={emojiDialogOpen}
        onClose={() => { setEmojiDialogOpen(false); setReactingWamid(null); }}
        maxWidth="xs"
        fullWidth
      >
        <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
          <Typography variant="h6">{reactingWamid ? 'React to Message' : 'Select Emoji'}</Typography>
          <Picker
            onEmojiSelect={handleEmojiClick}
            data={data}
            title={reactingWamid ? 'React to Message' : 'Pick your emoji'}
            emoji="point_up"
            style={{ width: '100%' }}
            showPreview={false}
            showSkinTones={false}
          />
        </Box>
      </Dialog>

    </Box>
  );
};

export default TeamChatView;
